import { PlatformLayout } from "./platform-layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BackupsContent } from "./platform-backups";
import { EncryptionMigrationContent } from "./platform-encryption-migration";
import { AlertsContent } from "./platform-seed-failure-alerts";
import { SeedFailuresContent } from "./platform-seed-failures";
import { BusinessTypesContent } from "./platform-business-types";
import { TalentTypesContent } from "./platform-talent-types";
import { CollaboratorRolesManager } from "@/components/manage-collaborator-roles";
import { HardDrive, Lock, Bell, AlertTriangle, Tag, Users } from "lucide-react";

export function OperationsContent() {
  return (
    <Tabs defaultValue="backups">
      <TabsList className="flex flex-wrap h-auto gap-1 mb-4">
        <TabsTrigger value="backups" data-testid="tab-ops-backups">
          <HardDrive className="h-4 w-4 mr-1.5" />
          Backups
        </TabsTrigger>
        <TabsTrigger value="encryption" data-testid="tab-ops-encryption">
          <Lock className="h-4 w-4 mr-1.5" />
          Encryption
        </TabsTrigger>
        <TabsTrigger value="alerts" data-testid="tab-ops-alerts">
          <Bell className="h-4 w-4 mr-1.5" />
          Alerts
        </TabsTrigger>
        <TabsTrigger value="seed-failures" data-testid="tab-ops-seed-failures">
          <AlertTriangle className="h-4 w-4 mr-1.5" />
          Seed Failures
        </TabsTrigger>
        <TabsTrigger value="business-types" data-testid="tab-ops-business-types">
          <Tag className="h-4 w-4 mr-1.5" />
          Business Types
        </TabsTrigger>
        <TabsTrigger value="talent-types" data-testid="tab-ops-talent-types">
          <Users className="h-4 w-4 mr-1.5" />
          Talent Types
        </TabsTrigger>
        <TabsTrigger value="collab-roles" data-testid="tab-ops-collab-roles">
          <Users className="h-4 w-4 mr-1.5" />
          Collaborator Roles
        </TabsTrigger>
      </TabsList>

      <TabsContent value="backups">
        <BackupsContent />
      </TabsContent>
      <TabsContent value="encryption">
        <EncryptionMigrationContent />
      </TabsContent>
      <TabsContent value="alerts">
        <AlertsContent />
      </TabsContent>
      <TabsContent value="seed-failures">
        <SeedFailuresContent />
      </TabsContent>
      <TabsContent value="business-types">
        <BusinessTypesContent />
      </TabsContent>
      <TabsContent value="talent-types">
        <TalentTypesContent />
      </TabsContent>
      <TabsContent value="collab-roles">
        <div className="max-w-xl">
          <CollaboratorRolesManager surface="platform" />
        </div>
      </TabsContent>
    </Tabs>
  );
}

export default function PlatformOperationsHub() {
  return (
    <PlatformLayout>
      <OperationsContent />
    </PlatformLayout>
  );
}
